import { track } from "./track";

const API = process.env.REACT_APP_BACKEND_URL;

const T = {
  it: {
    consent: "Per inviare è necessario il consenso al trattamento dei dati.",
    required: "Controlli i campi obbligatori (*).",
    noApi: "Invio non disponibile: telefoni al +39 351 429 5888 o scriva su WhatsApp.",
    sending: "Invio in corso…",
    invalid: "Controlli i dati inseriti e riprovi.",
    ok: "Grazie, richiesta inviata. La segreteria la ricontatterà al più presto.",
    failed: "Invio non riuscito.",
    alt: "In alternativa telefoni al +39 351 429 5888 o scriva su WhatsApp.",
  },
  en: {
    consent: "Please give your consent to the processing of your data to send the request.",
    required: "Please check the required fields (*).",
    noApi: "Sending is not available: please call +39 351 429 5888 or write on WhatsApp.",
    sending: "Sending…",
    invalid: "Please check the details you entered and try again.",
    tooMany: "Too many requests, please try again later or call the practice.",
    ok: "Thank you, your request has been sent. The front desk will contact you as soon as possible.",
    failed: "Sending failed.",
    alt: "Alternatively, call +39 351 429 5888 or write on WhatsApp.",
  },
};

export function initForm() {
  const form = document.getElementById("contact-form");
  const status = document.getElementById("form-status");
  if (!form || !status) return;
  const btn = form.querySelector('button[type="submit"]');
  const en = document.documentElement.lang === "en";
  const t = en ? T.en : T.it;

  const setStatus = (msg, kind) => {
    status.textContent = msg;
    status.className = `form-status ${kind || ""}`;
  };

  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    if (!form.checkValidity()) {
      const bad = form.querySelector(":invalid");
      bad?.focus();
      setStatus(bad?.type === "checkbox" ? t.consent : t.required, "err");
      return;
    }
    if (!API) {
      setStatus(t.noApi, "err");
      return;
    }
    const fd = new FormData(form);
    const body = {
      nome: String(fd.get("nome") || "").trim(),
      telefono: String(fd.get("telefono") || "").trim(),
      email: String(fd.get("email") || "").trim(),
      motivo: String(fd.get("motivo") || "Prima visita"),
      messaggio: String(fd.get("messaggio") || "").trim(),
      consenso_privacy: fd.get("consenso_privacy") === "on",
      website: String(fd.get("website") || ""),
    };
    btn.disabled = true;
    setStatus(t.sending);
    try {
      const res = await fetch(`${API}/api/contact`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        if (en) throw new Error(res.status === 429 ? t.tooMany : t.invalid);
        throw new Error(typeof data?.detail === "string" ? data.detail : t.invalid);
      }
      track("form_submit", { form: "contatti", motivo: body.motivo, lang: en ? "en" : "it" });
      form.reset();
      setStatus(t.ok, "ok");
    } catch (err) {
      setStatus(`${err.message || t.failed} ${t.alt}`, "err");
    } finally {
      btn.disabled = false;
    }
  });
}
